export default {
  节点标识: 'Node Identifier',
  节点地址: 'Node Address',
  节点名称: 'Node Name',
  系统版本: 'System Version',
  '使用率(%)': 'Usage Rate (%)',
  速度: 'Speed',
  '最大值(GB)': 'Max Value (GB)',
  '速度(B/s)': 'Speed (B/s)',
  温度: 'Temperature',
  时间: 'Time',
  提示: 'Tip',
  终端地址为空: 'Terminal Address is Empty',
  'AidLux Web终端': 'AidLux Web Terminal',
  '节点数据不存在，不能导出': 'Node Data Does Not Exist, Cannot Export',
  '资源监控-{slot0}.csv': 'Resource Monitoring-{slot0}.csv',
  显示区间: 'Display Interval',
  刷新: 'Refresh',
  刷新间隔: 'Refresh Interval',
  开始: 'Start',
  停止: 'Stop',
  'CSV-所有数据': 'CSV-All Data',
  'CSV-当前数据': 'CSV-Current Data',
  导出数据: 'Export Data',
  小时: 'Hour',
  分钟: 'Minute',
  秒: 'Second',
  '3秒': '3 Seconds',
  '30秒': '30 Seconds',
  '1分钟': '1 Minute',
  '15分钟': '15 Minutes',
  '30分钟': '30 Minutes',
  '1小时': '1 Hour',
  天: 'Day',
  '15分钟前': '15 Minutes Ago',
  前: 'Ago',
  相对时间: 'Relative Time',
  绝对时间: 'Absolute Time',
  现在: 'Now',
  '目标：': 'Target:',
  开始时间不能大于结束时间: 'Start Time Cannot Be Greater Than End Time',
  结束时间不能小于开始时间: 'End Time Cannot Be Less Than Start Time',
  至: 'To',
  AccessKey管理: 'AccessKey Management',
  修改密码: 'Change Password',
  退出登录: 'Logout',
  关闭: 'Close',
  重新生成: 'Regenerate',
  修改成功: 'Changed Success',
  '密码修改成功，请重新登录': 'Password Changed Success, Please Log In Again',
  原密码: 'Original Password',
  请输入原密码: 'Please Enter Original Password',
  新密码: 'New Password',
  请输入新密码: 'Please Enter New Password',
  确认密码: 'Confirm Password',
  请输入确认密码: 'Please Enter Confirm Password',
  Logo设置: 'Logo Settings',
  是否显示Logo: 'Show Logo',
  显示: 'Show',
  隐藏: 'Hide',
  Logo图片: 'Logo Image',
  图片大小不能超过2M: 'Image Size Cannot Exceed 2MB',
  还原: 'Restore',
  '授权到期日期:': 'Auth Expiry Date:',
  永久: 'Permanent',
  无: 'None',
  失败: 'Failed',
  未集成: 'Not Integrated',
  集成中: 'Integrating',
  已集成: 'Integrated',
  普通模式: 'Normal Mode',
  商业ROOT版: 'Commercial ROOT Version',
  商业版: 'Commercial Version',
  是: 'Yes',
  否: 'No',
  安装配置中: 'Installing Configuration',
  计划等待中: 'Waiting for Plan',
  下载安装包: 'Download Install Package',
  任务成功: 'Task Success',
  任务失败: 'Task Failed',
  任务终止: 'Task Terminated',
  立即升级: 'Upgrade Now',
  指定时间: 'Specify Time',
  异常页: 'Error Page',
  '对不起，您没有访问该资源的权限': 'Sorry, You Do Not Have Permission to Access This Resource',
  返回: 'Back',
  严重级别: 'Severity Level',
  发生时间: 'Occurrence Time',
  事件源: 'Event Source',
  请输入事件源: 'Please Enter Event Source',
  事件类型: 'Event Type',
  事件内容: 'Event Content',
  操作: 'Operation',
  '确认删除此项告警吗?': 'Are You Sure to Delete This Alarm?',
  '告警管理-{mo}.csv': 'Alarm Management-{mo}.csv',
  删除成功: 'Deleted Success',
  已取消上传: 'Upload Cancelled',
  新增应用: 'Add Application',
  '该应用正在部署中,不能覆盖': 'The Application Is Being Deployed, Cannot Overwrite',
  '该应用已存在,是否覆盖?': 'The Application Already Exists, Overwrite?',
  新增应用成功: 'Application Added Success',
  应用名称: 'Application Name',
  英文名称: 'English Name',
  应用版本: 'Version',
  更新日志: 'Update Log',
  '描 述': 'Description',
  创建部署任务成功: 'Deployment Task Created Success',
  分组名称: 'Group Name',
  输入分组名称: 'Enter Group Name',
  输入节点名称: 'Enter Node Name',
  已部署版本: 'Deployed Version',
  移除: 'Remove',
  应用部署: 'Application Deployment',
  取消: 'Cancel',
  确定: 'Confirm',
  节点列表: 'Node List',
  全部: 'All',
  已选中: 'Selected',
  选中: 'Select',
  条: 'Items',
  条1: 'Item',
  暂未部署: 'Not Deployed Yet',
  部署时间: 'Deployment Time',
  已部署节点: 'Deployed Nodes',
  序号: 'No.',
  名称: 'Name',
  最新版本: 'Latest Version',
  描述: 'Description',
  大小: 'Size',
  上传时间: 'Upload Time',
  部署: 'Deploy',
  '当前应用的所有版本都将删除,确认删除吗?': 'All Versions of the Current Application Will Be Deleted, Are You Sure?',
  删除: 'Delete',
  '新 增': 'Add',
  '所选中应用的所有版本都将删除,确认删除吗?': 'All Versions of the Selected Application Will Be Deleted, Are You Sure?',
  '删 除': 'Delete',
  请输入应用名称: 'Please Enter Application Name',
  版本: 'Version',
  '确认删除吗?': 'Are You Sure to Delete?',
  部署详情: 'Deployment Details',
  部署状态: 'Deployment Status',
  进行中: 'Deploying',
  部署成功: 'Success',
  部署失败: 'Failed',
  部署日志: 'Deployment Log',
  全部日志: 'All Logs',
  实时日志: 'Real-Time Logs',
  节点总数: 'Total Nodes',
  状态: 'Status',
  部署中: 'Deploying',
  '部署中:{slot0}': 'Deploying: {slot0}',
  '部署成功:{slot0}': 'Success: {slot0}',
  '部署失败:{slot0}': 'Failed: {slot0}',
  '将重新部署所有节点,确认重新部署吗?': 'All Nodes Will Be Redeployed, Are You Sure?',
  重新部署任务创建成功: 'Redeployment Task Created Success',
  重新部署: 'Redeploy',
  请选择应用: 'Please Select Application',
  请选择应用版本: 'Please Select Application Version',
  请输入节点名称: 'Please Enter Node Name',
  请输入分组名称: 'Please Enter Group Name',
  完成时间: 'Completion Time',
  '确认重新部署吗?': 'Are You Sure to Redeploy?',
  重新创建部署任务成功: 'Redeployment Task Created Success',
  详情: 'Details',
  运行日志: 'Running Logs',
  应用状态: 'Application Status',
  已停止: 'Stopped',
  运行中: 'Running',
  '确认重启运行的服务吗?': 'Are You Sure to Restart the Running Service?',
  重启成功: 'Restart Success',
  重启: 'Restart',
  '确认启动服务吗?': 'Are You Sure to Start the Service?',
  启动成功: 'Start Success',
  启动: 'Start',
  '确定停止运行的服务吗?': 'Are You Sure to Stop the Running Service?',
  停止成功: 'Stop Success',
  '确认卸载吗?': 'Are You Sure to Uninstall?',
  卸载成功: 'Uninstall Success',
  卸载: 'Uninstall',
  新增节点成功: 'New Node Added Success',
  编辑节点: 'Edit Node',
  新增节点: 'Add Node',
  超过最大长度20: 'Exceeds Maximum Length of 20',
  '设备管理.csv': 'Device Management.csv',
  导出配置: 'Export Configuration',
  节点状态: 'Node Status',
  节点状态不能为空: 'Node Status Cannot Be Empty',
  请选择节点状态: 'Please Select Node Status',
  在线: 'Online',
  离线: 'Offline',
  创建部署任务: 'Create Deployment Task',
  固件名称: 'Firmware Name',
  固件版本: 'Firmware Version',
  执行时间: 'Execution Time',
  已取消上传固件包: 'Firmware Package Upload Cancelled',
  固件新增成功: 'Firmware Added Success',
  固件新增: 'Add Firmware',
  请上传固件: 'Please Upload Firmware',
  固件类型: 'Firmware Type',
  整包: 'Full Package',
  差分: 'Differential',
  待升级版本: 'Pending Upgrade',
  选择固件: 'Select Firmware',
  上传固件: 'Upload Firmware',
  请添加描述信息: 'Please Add Description',
  超过最大长度200: 'Exceeds Maximum Length of 200',
  请添加固件说明: 'Please Add Firmware Description',
  未开始: 'Not Started',
  重启中: 'Restarting',
  开始时间: 'Start Time',
  '确定重新部署吗？': 'Are You Sure to Redeploy?',
  '确定删除吗？': 'Are You Sure to Delete?',
  设备状态: 'Device Status',
  执行时间修改成功: 'Execution Time Modified Success',
  编辑部署任务: 'Edit Deployment Task',
  立即执行: 'Now',
  '确定删除该固件吗？': 'Are You Sure to Delete This Firmware?',
  新增: 'Add',
  '确定删除所选固件吗？': 'Are You Sure to Delete the Selected Firmware?',
  请输入固件名称: 'Please Enter Firmware Name',
  '最大支持固件数:': 'Maximum Supported Firmware Count:',
  个: 'Items',
  '进行中:{slot0}': 'In Progress: {slot0}',
  成功: 'Success',
  '成功:{slot0}': 'Success: {slot0}',
  '失败:{slot0}': 'Failed: {slot0}',
  编辑: 'Edit',
  '确定删除该任务吗?': 'Are You Sure to Delete This Task?',
  删除任务成功: 'Task Deleted Success',
  '确定删除所选任务吗?': 'Are You Sure to Delete the Selected Tasks?',
  删除所选任务成功: 'Selected Tasks Deleted Success',
  设备码: 'Device Code',
  唯一标识: 'Unique Identifier',
  唯一标识复制成功: 'Unique Identifier Copied Success',
  集成命令: 'Integrate Command',
  集成命令复制成功: 'Integrated Command Copied Success',
  编辑成功: 'Edited Success',
  日志: 'Logs',
  软件包ID: 'Software Package ID',
  软件版本: 'Software Version',
  已取消上传软件包: 'Software Package Upload Cancelled',
  软件包新增成功: 'Software Package Added Success',
  软件包新增: 'Add Software Package',
  选择软件包: 'Software Package',
  上传软件包: 'Upload Software Package',
  '确定删除该软件包吗？': 'Are You Sure to Delete This Software Package?',
  '确定删除所选软件包吗？': 'Are You Sure to Delete the Selected Software Packages?',
  请输入软件包ID: 'Please Enter Software Package ID',
  '最大支持软件数:': 'Maximum Supported Software Count:',
  '确定删除吗?': 'Are You Sure to Delete?',
  节点分组: 'Node Group',
  Soc厂商: 'Soc Manufacturer',
  系统SN: 'System SN',
  设备序列号: 'Device SN',
  Soc型号: 'Soc Model',
  Soc详情: 'Soc Details',
  属性: 'Attributes',
  内容: 'Content',
  基本信息: 'Basic Information',
  硬件信息: 'Hardware Information',
  固件管理: 'Firmware Management',
  部署记录: 'Deployment Record',
  地址: 'Address',
  系统: 'System',
  启用: 'Enable',
  导入节点: 'Import Node',
  批量删除: 'Batch Delete',
  '最大支持设备数:': 'Maximum Supported Device:',
  不可导入: 'Cannot Be Imported',
  可导入: 'Can Be Imported',
  说明: 'Description',
  '确认删除吗？': 'Are You Sure to Delete?',
  节点新增成功: 'Node Added Success',
  上传文件: 'Upload File',
  网络分组: 'Network Group',
  请输入网络分组: 'Please Enter Network Group',
  节点名称不能为空: 'Node Name Cannot Be Empty',
  '导入模板:': 'Import Template:',
  '节点导入模板.csv': 'Node Import Template.csv',
  点我下载: 'Click to Download',
  '可导入节点{slot0}个,不可导入节点{slot1}个,是否继续?': 'Can Import {slot0} Nodes, Cannot Import {slot1} Nodes, Continue?',
  软件包管理: 'Software Package Management',
  首页: 'Home',
  '欢迎使用 Node Master': 'Welcome to Node Master',
  '用户名:': 'Username:',
  '密码:': 'Password:',
  '登 录': 'Login',
  注册成功: 'Registration Success',
  '欢迎使用AidLux NodeMaster': 'Welcome to AidLux NodeMaster',
  用户名: 'Username',
  必填项: 'Required Field',
  昵称: 'Nickname',
  密码: 'Password',
  密码不一致: 'Passwords Do Not Match',
  '注 册': 'Register',
  创建命令: 'Create Command',
  修改命令: 'Modify Command',
  命令详情: 'Command Details',
  创建成功: 'Created Success',
  命令名称: 'Command Name',
  请输入命令名称: 'Please Enter Command Name',
  '支持中文、字母、数字、下划线、分隔符"-",最大长度不超过60个字符': 'Supports Chinese, Letters, Numbers, Underscore, Separator "-", Maximum Length 60 Characters',
  命令描述: 'Description',
  不超过200个字符: 'No More Than 200 Characters',
  请输入命令描述: 'Please Enter Command Description',
  执行路径: 'Execution Path',
  请输入执行路径: 'Please Enter Execution Path',
  执行用户: 'Execution User',
  超时时间: 'Timeout',
  '可设置范围1～86400秒,默认60秒。超时后,会强制终止发送进程': 'Timeout Range 1-86400 Seconds, Default 60 Seconds. Timeout Will Force Termination of Sending Process',
  请输入超时时间: 'Please Enter Timeout',
  '请输入1-86400之间的数字': 'Please Enter a Number Between 1 and 86400',
  默认为60: 'Default is 60',
  命令内容: 'Command Content',
  请输入命令: 'Please Enter Command',
  执行命令下发成功: 'Command Executed Success',
  执行命令: 'Execute Command',
  复制成功: 'Copied Success',
  修改时间: 'Modification Time',
  执行: 'Execute',
  修改: 'Modify',
  请输入命令名称或描述: 'Please Enter Command Name or Description',
  结果: 'Result',
  执行状态: 'Execution Status',
  执行成功: 'Success',
  执行失败: 'Failed',
  '成功:': 'Success:',
  '失败:': 'Failed:',
  '执行中:': 'Executing:',
  执行时长: 'Execution Duration',
  '确认终止吗?': 'Are You Sure to Terminate?',
  终止成功: 'Termination Success',
  终止: 'Terminate',
  '确认重新执行吗?': 'Are You Sure to Re-execute?',
  重新执行成功: 'Re-execution Success',
  重新执行: 'Re-execute',
  节点IP: 'Node IP',
  执行中: 'Executing',
  查看执行输出: 'View Execution Output',
  命令管理: 'Command Management',
  执行记录: 'Execution Record',
  保存成功: 'Success',
  保存: 'Save',
  下发成功: 'Success',
  文件下发: 'File Distribute',
  下发路径: 'Delivery Path',
  NM根路径: 'NM Root Path',
  远程下载: 'Remote Download',
  '远程下载正在进行中,确认取消吗？': 'Remote Download is in Progress, Are You Sure to Cancel?',
  远程下载已取消: 'Remote Download Cancelled',
  '文件已存在，是否覆盖': 'File Already Exists, Overwrite?',
  URL地址: 'URL Address',
  请输入URL地址: 'Please Enter URL Address',
  URL地址不合法: 'Invalid URL Address',
  文件地址: 'File Address',
  文件名: 'File Name',
  请输入文件名: 'Please Enter File Name',
  文件名不合法: 'Invalid File Name',
  '文件名/夹': 'File/Folder Name',
  '权限/所有者': 'Permissions/Owner',
  文件大小: 'File Size',
  计算: 'Calculate',
  重命名: 'Rename',
  分享: 'Share',
  我的文件: 'My Files',
  请输入文件或目录名: 'Please Enter File or Directory Name',
  上传: 'Upload',
  新建文件夹: 'Create Folder',
  分享列表: 'Share List',
  下发: 'Distribute',
  '存储空间:': 'Storage Space:',
  文件夹名: 'Folder Name',
  请输入文件夹名: 'Please Enter Folder Name',
  文件夹名不合法: 'Invalid Folder Name',
  '重命名文件/夹': 'Rename File/Folder',
  创建分享: 'Create Share',
  分享名称: 'Share Name',
  请输入分享名称: 'Please Enter Share Name',
  名称不能超过255个字符: 'Name Cannot Exceed 255 Characters',
  名称不能为空: 'Name Cannot Be Empty',
  有效期: 'Validity Period',
  请选择有效期: 'Please Select Validity Period',
  一天: 'One Day',
  七天: 'Seven Days',
  分享详情: 'Share Details',
  分享地址: 'Share Address',
  过期时间: 'Expiration Time',
  '共(': 'Total (',
  '个文件)': 'Files)',
  上传状态: 'Upload Status',
  等待上传: 'Waiting to Upload',
  上传失败: 'Failed',
  上传成功: 'Success',
  '文件上传中,关闭将会取消上传,确定取消上传吗？': 'File Upload in Progress, Closing Will Cancel Upload, Are You Sure?',
  '存在以下重名文件,是否覆盖?': 'The Following Files Have the Same Name, Overwrite?',
  选择不覆盖将会把重名文件从上传列表中去除: 'Choose Not to Overwrite Will Remove the Duplicated Files From Upload List',
  取消上传: 'Cancel Upload',
  不覆盖: 'Do Not Overwrite',
  覆盖: 'Overwrite',
  开始上传: 'Start Upload',
  上传文件夹: 'Upload Folder',
  清空列表: 'Clear List',
  单个文件不允许超过5GB: 'Individual File Cannot Exceed 5GB',
  文件管理: 'File Management',
  下发记录: 'Distribute Record',
  下发状态: 'Distribution Status',
  下发失败: 'Failed',
  '下发中:': 'Distributing:',
  下发时间: 'Distribute Time',
  '确认重新下发吗?': 'Are You Sure to Re-distribute?',
  重新下发成功: 'Re-Distribute Success',
  重新下发: 'Re-distribute',
  下发中: 'Distributing',
  设备管理: 'Device Management',
  设备列表: 'Device List',
  设备详情: 'Device Details',
  告警管理: 'Alarm Management',
  事件监控: 'Event Monitoring',
  数据分析: 'Data Analysis',
  资源监控: 'Resource Monitoring',
  应用管理: 'Application Management',
  应用中心: 'Application Center',
  配置管理: 'Configuration Management',
  远程文件: 'Remote Files',
  远程命令: 'Remote Commands',
  服务器错误: 'Server Error',
  请求参数错误: 'Request Parameter Error',
  登陆已过期: 'Login Expired',
  请求地址不存在: 'Request Address Not Found',
  请求失败: 'Request Failed',
  '请求数据异常，请稍后再试!': 'Request Data Error, Please Try Again Later!',
  '网络连接异常，请稍后再试!': 'Network Connection Error, Please Try Again Later!',
  小于1秒: 'Less Than 1 Second',
  '{days}天{hours}时': '{days} Days {hours} Hours',
  '{hours}时{minutes}分': '{hours} Hours {minutes} Minutes',
  '{minutes}分{secs}秒': '{minutes} Minutes {secs} Seconds',
  '{secs}秒': '{secs} Seconds',
  '暂无数据，不能导出': 'No Data, Cannot Export',
  连接断开: 'Connection Disconnected',
  连接正常: 'Connection Normal',
  特别严重: 'Extremely Serious',
  严重: 'Serious',
  较重: 'Heavier',
  一般: 'Generally',
  硬件设备: 'Hardware Device',
  网络通信: 'Network Communication',
  处理异常: 'Exception Handling'
};